// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppc {
  padding: 20px 22px 16px;
  max-width: 520px;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.5;
}

.ppc__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 700;
}
.ppc__title mat-icon {
  color: #5ea1d8;
}

.ppc__lead {
  margin: 0 0 10px;
}

.ppc__list {
  list-style: none;
  margin: 0 0 12px;
  padding: 4px 0;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.ppc__list li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  min-width: 0;
}
.ppc__list li + li {
  border-top: 1px solid #f1f5f9;
}

.ppc__kind {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
}

.ppc__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.ppc__note {
  flex: 0 0 auto;
  font-size: 12px;
  color: #6b7280;
}

.ppc__muted {
  margin: 0 0 8px;
  font-size: 12px;
  color: #6b7280;
}

.ppc__actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.ppc__btn {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.ppc__btn--ghost {
  border: 1px solid #d0d7de;
  background: transparent;
  color: #374151;
}
.ppc__btn--primary {
  border: 0;
  background: #5ea1d8;
  color: #fff;
}

@media (max-width: 520px) {
  .ppc__actions .ppc__btn {
    flex: 1 1 100%;
  }
}
:host-context(body.theme-dark) .ppc {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .ppc__list {
  border-color: #334155;
}
:host-context(body.theme-dark) .ppc__list li + li {
  border-top-color: #1e293b;
}
:host-context(body.theme-dark) .ppc__note,
:host-context(body.theme-dark) .ppc__muted {
  color: #94a3b8;
}
:host-context(body.theme-dark) .ppc__btn--ghost {
  border-color: #334155;
  color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/promote-pack-confirm-dialog/promote-pack-confirm-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AAAJ;AAEI;EACE,6BAAA;AAAN;;AAKA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAFF;AAIE;EACE,yBAAA;EACA,uBAAA;EACA,cAAA;AAFJ;AAKE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;AAHJ;;AAOA;EACE;IACE,cAAA;EAJF;AACF;AAQE;EACE,cAAA;AANJ;AASE;EACE,qBAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAWE;;EAEE,cAAA;AATJ;AAYE;EACE,qBAAA;EACA,cAAA;AAVJ","sourcesContent":[".ppc {\n  padding: 20px 22px 16px;\n  max-width: 520px;\n  color: #1f2937;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.ppc__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 10px;\n  font-size: 18px;\n  font-weight: 700;\n\n  mat-icon {\n    color: #5ea1d8;\n  }\n}\n\n.ppc__lead {\n  margin: 0 0 10px;\n}\n\n.ppc__list {\n  list-style: none;\n  margin: 0 0 12px;\n  padding: 4px 0;\n  max-height: 260px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    min-width: 0;\n\n    & + li {\n      border-top: 1px solid #f1f5f9;\n    }\n  }\n}\n\n.ppc__kind {\n  flex: 0 0 auto;\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  color: #5ea1d8;\n}\n\n.ppc__name {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.ppc__note {\n  flex: 0 0 auto;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.ppc__muted {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.ppc__actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.ppc__btn {\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n\n  &--ghost {\n    border: 1px solid #d0d7de;\n    background: transparent;\n    color: #374151;\n  }\n\n  &--primary {\n    border: 0;\n    background: #5ea1d8;\n    color: #fff;\n  }\n}\n\n@media (max-width: 520px) {\n  .ppc__actions .ppc__btn {\n    flex: 1 1 100%;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .ppc {\n    color: #e2e8f0;\n  }\n\n  .ppc__list {\n    border-color: #334155;\n\n    li + li {\n      border-top-color: #1e293b;\n    }\n  }\n\n  .ppc__note,\n  .ppc__muted {\n    color: #94a3b8;\n  }\n\n  .ppc__btn--ghost {\n    border-color: #334155;\n    color: #e2e8f0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
